export default "<p *ngIf=\"new\">\n    Yes\n</p>\n<p *ngIf=\"!new\">\n    No\n</p>\n"